import { render, staticRenderFns } from "./IndicadorImportancia.vue?vue&type=template&id=bd8d3d2c&scoped=true"
import script from "./IndicadorImportancia.vue?vue&type=script&lang=js"
export * from "./IndicadorImportancia.vue?vue&type=script&lang=js"
import style0 from "./IndicadorImportancia.vue?vue&type=style&index=0&id=bd8d3d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8d3d2c",
  null
  
)

export default component.exports